// extracted by mini-css-extract-plugin
export default {"btop":"_6c31f01ab1 _029f7bf7bc e7ffe1ce16","icon":"f044ce33f6 _2188d81ae5","btoppink":"_945724eb97 _3624474fc6"};